import { cva } from 'class-variance-authority';

/**
 * The whole control is the button, label included.
 *
 * `items-center` with a gap rather than an absolutely-positioned label: the
 * click target becomes the full row, which is what a pointer user expects from
 * something that looks like one control.
 */
export const switchStyles = cva('inline-flex max-w-full items-center gap-2.5 text-left', {
  variants: {
    disabled: {
      true: 'cursor-not-allowed opacity-60',
      false: 'cursor-pointer',
    },
  },
  defaultVariants: { disabled: false },
});

export const trackStyles = cva(
  [
    'relative inline-flex h-5 w-9 shrink-0 items-center rounded-control border',
    'transition-colors',
  ],
  {
    variants: {
      checked: {
        true: 'border-accent bg-accent',
        false: 'border-border-strong bg-surface-sunken',
      },
    },
    defaultVariants: { checked: false },
  },
);

/**
 * The moving knob.
 *
 * Light surface token on both states, so it stays legible against the accent
 * fill when checked and against the sunken fill when not. A single fill colour
 * would vanish into the track it sits on.
 */
export const thumbStyles = cva(
  'inline-block size-3.5 rounded-control bg-surface-raised transition-transform',
  {
    variants: {
      checked: {
        true: 'translate-x-4',
        false: 'translate-x-0.5',
      },
    },
    defaultVariants: { checked: false },
  },
);

export const labelStyles = 'text-sm leading-snug text-content';
export const descriptionStyles = 'text-xs text-content-muted';